<div class="padding16">
    <app-home-outputs [nameTextColor]="'#666666'" [flatButton]="true"></app-home-outputs>
</div>